import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute, { KidProtectedRoute, AdminProtectedRoute } from "./components/ProtectedRoute";
import ParentLayout from "./components/ParentLayout";

import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Register from "./pages/Register";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";

import Home from "./pages/parent/Home";
import MissionStudio from "./pages/parent/MissionStudio";
import RewardsShop from "./pages/parent/RewardsShop";
import Family from "./pages/parent/Family";
import Kiosk from "./pages/parent/Kiosk";
import Inbox from "./pages/parent/Inbox";
import Settings from "./pages/parent/Settings";

import KidsEntry from "./pages/kids/KidsEntry";
import KidDashboard from "./pages/kids/KidDashboard";

import Legal from "./pages/legal/Legal";
import AdminDashboard from "./pages/admin/AdminDashboard";
import "./App.css";

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <Toaster position="top-center" richColors toastOptions={{ style: { fontFamily: "Quicksand, sans-serif", fontWeight: 600 } }} />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />

          <Route path="/app" element={<ProtectedRoute><ParentLayout /></ProtectedRoute>}>
            <Route index element={<Home />} />
            <Route path="chores" element={<MissionStudio />} />
            <Route path="rewards" element={<RewardsShop />} />
            <Route path="family" element={<Family />} />
            <Route path="kiosk" element={<Kiosk />} />
            <Route path="inbox" element={<Inbox />} />
            <Route path="settings" element={<Settings />} />
          </Route>

          <Route path="/kids" element={<KidsEntry />} />
          <Route path="/kids/play" element={<KidProtectedRoute><KidDashboard /></KidProtectedRoute>} />

          <Route path="/admin" element={<AdminProtectedRoute><AdminDashboard /></AdminProtectedRoute>} />

          <Route path="/privacy" element={<Legal page="privacy" />} />
          <Route path="/terms" element={<Legal page="terms" />} />
          <Route path="/support" element={<Legal page="support" />} />
          <Route path="/delete-account" element={<Legal page="delete-account" />} />
          <Route path="/parents" element={<Legal page="parents" />} />

          <Route path="*" element={<Landing />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
